import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useRootPage } from '../../hooks/useRootPage';

interface NavItemProps {
  to: string;
  icon: JSX.Element;
  text: string;
}

export const NavItem: React.FC<NavItemProps> = ({ to, icon, text }) => {
  const location = useLocation();
  const rootPage = useRootPage();

  const isActive = ({ isActive }: { isActive: boolean }) => {
    const isRootPath = location.pathname === '/';
    const isRootActive = isRootPath && `/${rootPage}` === to;
    return `nav-link ${isActive || isRootActive ? 'active' : ''}`;
  };

  return (
    <li className="nav-item">
      <NavLink to={to} className={isActive}>
        {icon}
        <span className="nav-text">{text}</span>
      </NavLink>
    </li>
  );
};
